import React from "react";
import TabPanel, { Item } from "devextreme-react/tab-panel";
import Detail from "./Detail";
import Insurance from "./Insurance";
import Payment from "./Payment";
import Education from "./Education";
import Foreigner from "./Foreigner";
import Health from "./Health";
import Others from "./Others";
import "./style.scss";

export default function TabApprovalSetting({ convertDateTime, employee }) {
  const {
    AccountNo,
    BankName,
    OriginalBeneficiary,
    PasswordToOpenPayslip,
    BankBranch,
    IsBankTransfer,
    IsReceivePayslipByEmail,
    Height,
    Weight,
    BloodTypeName,
    Vehicle,
    CompanyCarNumber,
    InsuranceMonths,
    RemarkFirst,
    RemarkSecond,
    RemarkThird,
    DrivingLicenseNo,
    KmQuantity,
    GraduateSchool,
    EducationRank,
    Certificate,
    Major,
    IsSocialInsurance,
    IsHealthyInsurance,
    IsUnemploymentInsurance,
    InsStartDate,
    HouseholdNo,
    InsuranceBookNo,
    National,
    CitizenIDNo,
    CitizenExpiredDateFirstTime,
    IDNo,
    HometownAddress,
    BirthCity,
    BirthDistrict,
    BirthWard,
    BirthAddress,
    NativeCity,
    NativeDistrict,
    NativeWard,
    NativeAddress,
    TemporaryCity,
    TemporaryDistrict,
    TemporaryWard,
    TemporaryAddress,
    Email,
    CitizenIDIssueDate,
    HometownDistrict,
    HometownWard,
    PhoneNumber,
    CitizenExpiredDateThirdTime,
    MaritalStatus,
    Ethnic,
    Religion,
    PassportNo,
    PassportEffectDate,
    CitizenExpiredDateSecondTime,
    PassportExpireDate,
    DispatchCompany,
    AppointFromDate,
    AppointToDate,
    ReturnDate,
    VisaExpireDate,
    VisaNo,
    VisaNoFirstTime,
    VisaNoSecondTime,
    VisaNoThirdTime,
    VisaFirstExpiredDate,
    VisaSecondExpiredDate,
    VisaThirdExpiredDate,
    IsVisaFirstTime,
    IsVisaSecondTime,
    IsVisaThirdTime,
    WorkPermitNo,
    WorkPermitFromDate,
    WorkPermitExpiredDate,
    IsWorkPermitFirstTime,
    IsWorkPermitSecondTime,
    IsWorkPermitThirdTime,
    WorkPermitNoFirst,
    WorkPermitNoSecond,
    WorkPermitNoThird,
    WorkPermitFirstExpired,
    WorkPermitSecondExpired,
    WorkPermitThirdExpired,
    TempResidenceNo,
    TempResidenceEffectDate,
    TempResidenceExpireDate,
    PerAddressAtViet,
    PhoneNumberInCountry,
    ContactPerson,
    Relationship,
  } = employee;
  const foreigner = {
    DispatchCompany,
    AppointFromDate,
    AppointToDate,
    ReturnDate,
    VisaExpireDate,
    VisaNo,
    VisaNoFirstTime,
    VisaNoSecondTime,
    VisaNoThirdTime,
    VisaFirstExpiredDate,
    VisaSecondExpiredDate,
    VisaThirdExpiredDate,
    IsVisaFirstTime,
    IsVisaSecondTime,
    IsVisaThirdTime,
    WorkPermitNo,
    WorkPermitFromDate,
    WorkPermitExpiredDate,
    IsWorkPermitFirstTime,
    IsWorkPermitSecondTime,
    IsWorkPermitThirdTime,
    WorkPermitNoFirst,
    WorkPermitNoSecond,
    WorkPermitNoThird,
    WorkPermitFirstExpired,
    WorkPermitSecondExpired,
    WorkPermitThirdExpired,
    TempResidenceNo,
    TempResidenceEffectDate,
    TempResidenceExpireDate,
    PerAddressAtViet,
    PhoneNumberInCountry,
    ContactPerson,
    Relationship,
  };
  const detail = {
    National,
    CitizenIDNo,
    CitizenExpiredDateFirstTime,
    IDNo,
    HometownAddress,
    BirthCity,
    BirthDistrict,
    BirthWard,
    CitizenIDIssueDate,
    CitizenExpiredDateThirdTime,
    HometownWard,
    BirthAddress,
    HometownDistrict,
    PhoneNumber,
    NativeCity,
    NativeDistrict,
    NativeWard,
    NativeAddress,
    TemporaryCity,
    TemporaryDistrict,
    TemporaryWard,
    TemporaryAddress,
    MaritalStatus,
    Ethnic,
    Religion,
    Email,
    PassportNo,
    PassportEffectDate,
    PassportExpireDate,
    CitizenExpiredDateSecondTime,
  };
  const payment = {
    AccountNo,
    BankName,
    OriginalBeneficiary,
    PasswordToOpenPayslip,
    BankBranch,
    IsBankTransfer,
    IsReceivePayslipByEmail,
  };
  const insurance = {
    IsSocialInsurance,
    IsHealthyInsurance,
    IsUnemploymentInsurance,
    InsStartDate,
    HouseholdNo,
    InsuranceBookNo,
  };
  const education = {
    GraduateSchool,
    EducationRank,
    Certificate,
    Major,
  };
  const health = {
    Height,
    Weight,
    BloodTypeName,
  };
  const other = {
    Vehicle,
    CompanyCarNumber,
    InsuranceMonths,
    RemarkFirst,
    RemarkSecond,
    RemarkThird,
    DrivingLicenseNo,
    KmQuantity,
  };
  return (
    <TabPanel focusStateEnabled={false} className="mt-2 tab-panel-employee">
      <Item title="Detail">
        <Detail detail={detail} convertDateTime={convertDateTime} />
      </Item>
      <Item title="Insurance">
        <Insurance convertDateTime={convertDateTime} insurance={insurance} />
      </Item>
      <Item title="Payment">
        <Payment payment={payment} />
      </Item>
      <Item title="Education">
        <Education education={education} />
      </Item>
      <Item title="Foreigner">
        <Foreigner foreigner={foreigner} convertDateTime={convertDateTime} />
      </Item>
      <Item title="Health">
        <Health health={health} />
      </Item>
      <Item title="Others">
        <Others other={other} />
      </Item>
    </TabPanel>
  );
}
